import { QueryClient } from '@tanstack/react-query';

import { parseMedicalCategoriesVo } from '@/parsers/f2f/hospital';
import { MedicalCategorySortType } from '@/types/bff/gql-schema';

import { useMedicalCategoriesQuery } from './hospitalMain.gql.impl';

interface Params {
  sortType: MedicalCategorySortType;
  enabled?: boolean;
}
const useMedicalCategories = ({ sortType, enabled = true }: Params) => {
  const { data } = useMedicalCategoriesQuery(
    {
      request: {
        sortType,
      },
    },
    { select: parseMedicalCategoriesVo, enabled: enabled },
  );
  return { data };
};

export default useMedicalCategories;

useMedicalCategories.prefetchQuery = async (
  queryClient: QueryClient,
  sortType: MedicalCategorySortType,
) => {
  await queryClient.prefetchQuery(
    useMedicalCategoriesQuery.getKey({ request: { sortType } }),
    useMedicalCategoriesQuery.fetcher({ request: { sortType } }),
  );
};
useMedicalCategories.fetchQuery = async (
  queryClient: QueryClient,
  sortType: MedicalCategorySortType,
) => {
  const response = await queryClient.fetchQuery(
    useMedicalCategoriesQuery.getKey({ request: { sortType } }),
    useMedicalCategoriesQuery.fetcher({ request: { sortType } }),
  );

  return parseMedicalCategoriesVo(response);
};
